import axios, { AxiosRequestHeaders } from 'axios';

import { getSharedAuthEnabled } from '@/features/toggl-accounts';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL + '/api/v1',
  withCredentials: getSharedAuthEnabled(),
});

const configuration: { authToken: string | null } = {
  authToken: null,
};

api.interceptors.request.use((request) => {
  if (configuration.authToken) {
    request.headers = {
      Authorization: `Bearer ${configuration.authToken}`,
      ...request.headers,
    } as AxiosRequestHeaders;
  }

  return request;
});

export default api;

export function setAuthToken(authToken: string) {
  configuration.authToken = authToken;
}

export function deleteAuthToken() {
  configuration.authToken = null;
}
